/*
 * @Author: Vanny
 * @Date: 2019-09-04 19:51:18
 * @LastEditors: Vanny
 * @LastEditTime: 2019-11-21 10:13:04
 * @Description: 时间、日期处理
 */
import moment, { unitOfTime } from 'moment';

// 日期格式化
export const formatDate = (origin?: string, format = 'YYYY-MM-DD') => moment(origin).format(format);

// XX 天前
export const beforeDate = (
  num: number = 15,
  type: unitOfTime.DurationConstructor = 'd',
  format = 'YYYY-MM-DD'
) =>
  moment()
    .endOf(type)
    .add(1, 'ms')
    .subtract(num, type)
    .format(format);
/**
 * 一季度  0  0  2
 * 二季度  1  3  5
 * 三季度  2  6  8
 * 四季度  3  9  11
 * @param year
 * @param season
 */
export function getSeasonRange(year: any, season: number, format = 'YYYY-MM-DD') {
  const date = moment({ year });

  const index = (season - 1) % 4;
  return [
    date
      .startOf('month')
      .month(index * 3)
      .format(format),
    date
      .startOf('month')
      .month(index * 3 + 2)
      .format(format),
  ];
}
